import { Permissions } from '../../../reducers/root.reducer';

export const inventoryPermissions: Permissions = [
  'EditInventoryStockItems',
  'ViewInventoryStockItems',
  'ViewInventoryReports',
  'EditInventoryPurchaseOrders',
  'ViewInventoryPurchaseOrders',
  'EditInventorySupplier',
  'ViewInventorySupplier',
  'EditInventoryTrackingProfiles',
  'ViewInventoryTrackingProfiles',
];
